import React from "react";
import { gray5, red } from "assets/styleUtils";
import styles from "./style.module.css";
import { IProductItem } from "data/company";
import { TextSection } from "components";
import { exceptCommentCategories } from "./CompanyDetailPage";

export default function ProductItem({
  productItme,
  category,
  specialCategories,
}: {
  productItme: IProductItem;
  category: string;
  specialCategories: string[];
}) {
  const {
    product_name,
    product_price,
    product_content,
    product_img,
    product_discount_price,
    view_price_type,
  } = productItme;

  return (
    <section className={styles.product}>
      <div style={{ display: "flex" }}>
        <img
          src={product_img ? product_img : "/images/logo.png"}
          alt={product_name}
        />
        <div
          style={{
            marginTop: "10px",
            marginLeft: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className={styles.productName}>{product_name}</div>

          <div style={{}}>
            {/* 할인율버전 */}
            {view_price_type === "rate" && (
              <>
                <div className={styles.priceText}>판매가</div>
                <div
                  style={{
                    textDecoration: "line-through",
                    marginBottom: "-4px",
                  }}
                >
                  {Number(product_price).toLocaleString()}원
                </div>
                <div style={{ display: "flex" }}>
                  <div
                    className={styles.productName}
                    style={{
                      color: red,
                    }}
                  >
                    {product_discount_price}%
                  </div>
                  <div
                    className={styles.productName}
                    style={{
                      marginLeft: "10px",
                    }}
                  >
                    {(
                      Number(product_price) -
                      (Number(product_price) * Number(product_discount_price)) /
                        100
                    ).toLocaleString()}
                    원
                  </div>
                </div>
              </>
            )}
            {/* 할인가버전 */}
            {view_price_type === "price" && (
              <div>
                <div
                  className={styles.priceText}
                  style={{ marginBottom: "-5px" }}
                >
                  판매가
                </div>

                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      textDecoration: "line-through",
                      display: "flex",
                      alignItems: "end",
                    }}
                  >
                    {Number(product_price).toLocaleString()}원
                  </div>
                  <div
                    className={styles.productName}
                    style={{
                      marginLeft: "10px",
                    }}
                  >
                    {Number(product_discount_price).toLocaleString()}원
                  </div>
                </div>
              </div>
            )}

            {/* 정가 */}
            {view_price_type === "krw" && (
              <>
                <div className={styles.priceText}>판매가</div>

                <div className={styles.productName}>
                  {Number(product_price).toLocaleString()}원
                </div>
              </>
            )}
            {/* 업체문의 */}
            {view_price_type === "etc" && (
              <div>
                <div className={styles.priceText}>판매가</div>

                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "bolder",
                  }}
                >
                  가격 문의
                </div>
                {/*exceptCommentCategories가 아닌 업체들 중에서 안내멘트*/}
                {!exceptCommentCategories.includes(category) && (
                  <div
                    style={{
                      marginTop: "-2px",
                      fontSize: "11px",
                    }}
                  >
                    {specialCategories.includes(category)
                      ? "(하단에 견적 문의 버튼 클릭 후 문의 주시면 금액을 안내드립니다.)"
                      : "(예약 넣어주시면 금액을 안내드립니다.)"}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {product_content && (
        <>
          <div
            style={{
              width: "100%",
              height: "1px",
              backgroundColor: gray5,
              margin: "10px 0px",
            }}
          />
          <TextSection
            data={product_content}
            fontSize={"15px"}
            fontWeight="500"
            marginBottom={"0px"}
          />
        </>
      )}
    </section>
  );
}
